module.exports = __webpack_public_path__ + "img/welcome-cube.abe5b713.gif";